import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface PadvishRequestLicenseSliceState {
    list: any,
  }
  
const initialState:PadvishRequestLicenseSliceState = {
    list:undefined,
}

export const PadvishRequestLicenseSlice = createSlice({
    name:"padvishRequestLicenseList",
    initialState,
    reducers:{
        UpdatePadvishRequestLicenseList: (state,action) => {
            state.list = action.payload.padvishRequestLicenseList;
        },
        AddPadvishRequestLicense: (state,action) => {
            state.list = undefined;
        },
        EditPadvishRequestLicense: (state,action) => {
            state.list = undefined;
        },
        RemovePadvishRequestLicense: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdatePadvishRequestLicenseList,AddPadvishRequestLicense,EditPadvishRequestLicense,RemovePadvishRequestLicense} = PadvishRequestLicenseSlice.actions

export const selectPadvishRequestLicenseList = (state: RootState) => state.padvishRequestLicenseList

export default PadvishRequestLicenseSlice.reducer;